import Swiper from "swiper/bundle";

const ProductSlider = () => {
   const productSmallSlider = new Swiper(".product__slider-small", {
    slidesPerView: 4,
    spaceBetween: 20,
    freeMode: true,
    loop: true,
     breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4, 
      }
    },
  });
  
  const productBigSlider = new Swiper(".product__slider-big", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    thumbs: {
      swiper: productSmallSlider,
    },
  });
}

export default ProductSlider;